import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { isUnauthorizedWithoutSession } from './isUnauthorizedWithoutSession';
import { showApiErrorToast } from './showApiErrorToast';

export type ErrorToastMeta = {
  suppressErrorToast?: boolean;
  errorToastFallback?: string;
};

export const createAppQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000 * 30,
      },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        const meta = mutation.meta as ErrorToastMeta | undefined;
        if (meta?.suppressErrorToast || isUnauthorizedWithoutSession(error)) {
          return;
        }

        showApiErrorToast(error, meta?.errorToastFallback);
      },
    }),
    queryCache: new QueryCache({
      onError: (error, query) => {
        const meta = query.meta as ErrorToastMeta | undefined;
        if (meta?.suppressErrorToast || isUnauthorizedWithoutSession(error)) {
          return;
        }

        showApiErrorToast(
          error,
          meta?.errorToastFallback ?? 'Não foi possível carregar os dados.',
        );
      },
    }),
  });
